<template>
  <div>
    <Dialog
      v-bind="$attrs"
      v-on="$listeners"
      :visible="show"
      :title="locale.joinCivi"
    >
      <h3>{{ locale.isJoin | formatter(name) }}</h3>
      <p>{{ locale.cannotChange }}</p>
      <button
        v-gtag:joinConfirm
        data-type="button"
        class="dialog-btn join-civi"
        @click="join('join')"
      >
        <span
          ><i v-if="loading" class="loading el-icon-refresh-right"></i>
          {{ locale.confirm }}</span
        >
      </button>
      <span
        v-gtag:joinCancel
        data-type="link"
        class="think-again"
        @click="join('close')"
        >{{ locale.cancel }}</span
      >
    </Dialog>

    <DlgShare
      :title="$locale.dialog.joinedSuccess.success"
      :content="$locale.dialog.joinedSuccess.toShare"
      :name="name"
      :visible="joinedShow"
      @close="joined('close')"
    />
  </div>
</template>

<script>
import Dialog from "./dlg.vue";
import DlgShare from "./share.vue";
import { mapActions } from "vuex";

export default {
  name: "JoinDialog",
  props: ["id", "name", "visible"],
  components: {
    Dialog,
    DlgShare,
  },
  data() {
    return {
      locale: this.$locale.dialog.join,
      show: false,
      joinedShow: false,
      loading: false,
    };
  },
  created() {},
  mounted() {},
  watch: {
    visible: {
      handler(val) {
        this.show = val;
        console.log(this.id, this.name);
      },
      immediate: true,
    },
  },
  filters: {
    formatter(val, replacer) {
      if (!Array.isArray(replacer)) {
        replacer = [replacer];
      }
      const res = val?.replaceAll(/\$\{(\d+)\}/g, function () {
        return replacer[arguments[1]];
      });
      return res;
    },
  },
  computed: {},
  methods: {
    ...mapActions(["joinCivi"]),
    join(action) {
      const events = {
        open: () => {
          this.show = true;
        },
        close: () => {
          this.show = false;
          this.$emit("close");
        },
        join: () => {
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.joinCivi({ guild: this.id })
            .then((res) => {
              this.join("success");
            })
            .finally(() => {
              this.loading = false;
            });
        },
        success: () => {
          this.$emit("success");
          this.join("close");
          this.joined("open");
        },
      };

      events[action]?.();
    },
    joined(action) {
      if (action == "open") {
        this.joinedShow = true;
      } else if (action == "close") {
        this.joinedShow = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .dialog {
  &-body {
    padding: 40px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: 25px;
    text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
      0px 0px 1px rgba(255, 233, 129, 0.69);
  }
}

h3,
p,
button,
.think-again {
  margin: 20px 0;
}

h3 {
  font-weight: normal;
  color: var(--primary-color);
}

p {
  font-size: 18px;
  color: #ffc55c;
}

.think-again {
  color: var(--primary-color);
}
</style>
